import React from 'react';
import styled from 'styled-components';
import RowItem from './RowItem';
import PlaceHolder from '../Placeholder/Placeholder';
function RowItems(props) {
	const {columns, groupConfig, listData, listRowItemClassName} = props;

	// Get the level of entity. Its required to apply css colors on groupped item
	const getEntityLevel = (listData) => {
		if (listData && listData[0] && listData[0].nodeLevel) {
			return 'level' + listData[0].nodeLevel;
		}
		return '';
	};

	return (
		<>
			{
				<StyledRowItemContainer className={`items-group-header ${getEntityLevel(listData)}`}>
					{listData &&
						listData.map((rowData, index) => {
							return (
								<RowItem
									rowData={rowData}
									groupConfig={groupConfig}
									key={props.getRowItemComponentKey ? props.getRowItemComponentKey(rowData, index) : `${index}_RowCell`}
									columns={columns}
									cellType={'RowCell'}
									className={listRowItemClassName}
									rowIndex={index}
								></RowItem>
							);
						})}
					{/* <section className="default-msg">There are no engagements available for the client(s) that you selected on Step 1. Return to Step 1 and select a different client to continue.</section> */}
				</StyledRowItemContainer>
			}
		</>
	);
}

export default RowItems;

const StyledRowItemContainer = styled.section`
	.default-msg {
		font-size: 1.4rem;
		width: 40rem;
	}

	&.level1{
		border-left: solid 4px ${(props) => props.theme.color[`green400`]};
	}
	&.level2{
			border-left: solid 4px ${(props) => props.theme.color[`blue400`]};
	}
	&.level3{
			border-left: solid 4px ${(props) => props.theme.color[`orange500`]};
	}
	&.level4{
			border-left: solid 4px ${(props) => props.theme.color[`purple200`]};
	}
`;
